import React from "react";

import { FaFacebookF, FaTwitter, FaInstagram, FaLinkedinIn, FaYoutube } from "react-icons/fa";

const instructors = [
  {
    id: 1,
    name: "Chris Martin",
    role: "Freelancer",
    subject: "Computer Science",
    type: "experience",
    image: "https://picsum.photos/400/550?random=501"
  },
  {
    id: 2,
    name: "John Deo",
    role: "Fashion Designer",
    subject: "Mathematics",
    type: "students",
    image: "https://picsum.photos/400/550?random=502"
  },
  {
    id: 3,
    name: "Riya Ronaldo",
    role: "Manager",
    subject: "Commerce",
    type: "expert",
    image: "https://picsum.photos/400/550?random=503"
  },
//   {
//     id: 4,
//     name: "Martina Deo",
//     role: "Managing Director",
//     subject: "Economics",
//     type: "subject",
//     image: "https://picsum.photos/400/550?random=504"
//   }
];

function getBottomLabel(ins) {
  switch (ins.type) {
    case "experience":
      return "⭐ 5+ Years Experience";
    case "students":
      return "🏫 Taught 2000+ Students";
    case "expert":
      return "🎯 Expert Instructor";
    case "subject":
    default:
      return `📘 ${ins.subject}`;
  }
}

const TeamCard2 = () => {
  return (<>
    <section className="latest-sec-tc2">
      <div className="latest-head-tc2">
        <h2>LATEST INSTRUCTORS</h2>
        <p>
          Lorem ipsum is simply dummy text of the printing and typesetting
          industry. Replace this with your own brief intro.
        </p>
      </div>

      <div className="latest-row-tc2">
        {instructors.map((ins) => (
          <article key={ins.id} className="latest-card-tc2">
            {/* circle avatar */}
            <div className="avatar-wrap-tc2">
              <img src={ins.image} alt={ins.name} />

              {/* social icons like previous component */}
              <div className="social-bar-tc2">
                 <a href="#">  <FaFacebookF />
                                            </a>
                                <a href="#"><FaTwitter />
                                           </a>
                                <a href="#"> <FaInstagram />
                                           </a>
                                <a href="#"> <FaLinkedinIn />
                                            </a>
              </div>
            </div>

            {/* card body */}
            <div className="card-inner-tc2">
              <h3>{ins.name}</h3>
              <p className="role-tc2">{ins.role}</p>
              <p className="bottom-label-tc2">
                <strong>{getBottomLabel(ins)}</strong>
              </p>
              <span className="underline-tc2" />
            </div>
          </article>
        ))}
      </div>
    </section>
    <style>{`.latest-sec-tc2 {
  padding: 60px 8%;
  background: #f7f7f9;
  font-family: system-ui, -apple-system, "Segoe UI", sans-serif;
}

.latest-head-tc2 {
  text-align: center;
  margin-bottom: 40px;
}

.latest-head-tc2 h2 {
  font-size: 28px;
  letter-spacing: 1px;
  font-weight: 800;
  margin-bottom: 8px;
}

.latest-head-tc2 p {
  max-width: 640px;
  margin: 0 auto;
  font-size: 14px;
  color: #777;
}

/* row */
.latest-row-tc2 {
  display: flex;
  gap: 24px;
  justify-content: center;
  flex-wrap: wrap;
}

/* each card */
.latest-card-tc2 {margin-top:50px;
  position: relative;
  width: 260px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.06);
  padding-top: 60px; /* space for avatar overlap */
  transition: 0.3s ease;
}

/* circular avatar */
.avatar-wrap-tc2 {
  position: absolute;
  top: -55px;
  left: 50%;
  transform: translateX(-50%);
  width: 110px;
  height: 110px;
  border-radius: 50%;
  border: 4px solid #fff;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.avatar-wrap-tc2 img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* social icons sliding up */
.social-bar-tc2 {
  position: absolute;
  bottom: -40px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 8px;
  transition: 0.3s ease;
}
.social-bar-tc2 {
  position: absolute;
  top: -20px; /* above image */
  left: 50%;
  transform: translateX(-50%);
  width: 140px; /* width of arc */
  height: 70px; /* arc height */
  display: flex;
  justify-content: space-around;
  pointer-events: auto;
}

.social-bar-tc2 a {
  width: 28px;
  height: 28px;
  background: #ffffff;
  color: #222222;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  font-size: 12px;
  text-decoration: none;
  position: absolute;
  transition: 0.35s ease;
}

/* Semi-circle positioning */
.social-bar-tc2 a:nth-child(1) {
  top: 40px;
  left: 15px;
}

.social-bar-tc2 a:nth-child(2) {
  top: 10px;
  left: 35px;
}

.social-bar-tc2 a:nth-child(3) {
  top: 10px;
  right: 35px;
}

.social-bar-tc2 a:nth-child(4) {
  top: 40px;
  right: 15px;
}

/* Hover animation */
.social-bar-tc2 a:hover {
 
  background: rgba(144, 202, 249,1);
}
  .latest-card-tc2:hover .social-bar-tc2 a {
  opacity: 1;
  transform: translateY(16px);
}
   .latest-card-tc2:hover .avatar-wrap-tc2 img {opacity:0.5;}

.social-bar-tc2 a {
  opacity: 0;
  transform: translateY(4px);
}

/* slide up on card hover */
.latest-card-tc2:hover .social-bar-tc2 {
  bottom: 6px;
}

/* inner text */
.card-inner-tc2 {
  padding: 35px 18px 18px;
  text-align: center;
}

.card-inner-tc2 h3 {
  font-size: 16px;
  font-weight: 800;
  margin-bottom: 4px;
  text-transform: uppercase;
}

.card-inner-tc2 .role-tc2 {
  font-size: 13px;
  color: #777;
  margin-bottom: 10px;
}

.bottom-label-tc2 {
  font-size: 13px;
  color: #222;
  margin-bottom: 10px;
}

/* small underline-tc2 accent */
.underline-tc2 {
  display: block;
  width: 60px;
  height: 3px;
  border-radius: 999px;
  background: rgba(144, 202, 249,1);
  margin: 0 auto 4px;
}

/* hover lift */
.latest-card-tc2:hover {
  transform: translateY(-8px);
}

/* responsive */
@media (max-width: 768px) {
  .latest-card-tc2 {
    width: 100%;
    max-width: 330px;
  }
}
`}</style>
  </>);
};

export default TeamCard2;
